import { useEffect } from "react"
import { useLocation, useHistory } from "react-router-dom"

import { useAssertRootQueryLoaded } from "graphql/smart-queries/user"
import { useSetCurrentVanityUrl } from "graphql/mutations/setCurrentVanityUrl"

export const VanityUrlRedirect = () => {
  const history = useHistory()
  const location = useLocation()
  const { vanityUrls } = useAssertRootQueryLoaded()
  const [setCurrentVanityUrl] = useSetCurrentVanityUrl()

  const parsedVanityUrl = vanityUrls.find(
    ({ active, vanityUrl }) => active && vanityUrl === location.pathname.replace("/", "")
  )

  if (!parsedVanityUrl) {
    history.push("/not-found")
  }

  useEffect(() => {
    async function vanityRedirect() {
      if (parsedVanityUrl) {
        const { errors, data } = await setCurrentVanityUrl({
          variables: {
            id: parsedVanityUrl.id
          }
        })

        if (errors) {
          throw errors
        }

        if (data?.vanityUrl?.redirectPath) {
          const { redirectPath, utmCampaign, utmMedium, utmSource } = data.vanityUrl
          const utmParams = `utm_campaign=${utmCampaign}&utm_medium=${utmMedium}&utm_source=${utmSource}`

          history.push(`${redirectPath}?${utmParams}`)
        } else {
          history.push("/not-found")
        }
      }
    }

    vanityRedirect()
  }, [parsedVanityUrl])

  return null
}
